<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>Partner Dashboard</span>
    </fury-title>
</fury-page>

<fury-page  class="dashboard" fxLayout="column">

    
      <div fxLayout="column" fxLayoutAlign="center center">
        <div class="dashboardbody">
            <div class="innerdashbody partnerbody parner-dash">
                <div class="tab-wrap">
                    <mat-tab-group animationDuration="0ms" (selectedTabChange)="parentTabChange($event)">
                        <mat-tab label="All">
                            <fury-common-kpi-blocks [mainPage]="'partnerDashboard'" [data]="partnerKpiData" [partnerDashboardTabName]="parentTabName"></fury-common-kpi-blocks>
                        </mat-tab>
                        <mat-tab label="Web">
                            <fury-common-kpi-blocks [mainPage]="'partnerDashboard'" [data]="partnerKpiData" [partnerDashboardTabName]="parentTabName"></fury-common-kpi-blocks>
                            <div class="tab-wrap">
                                <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)" *ngIf="parentTabName==='Web'">
                                    <mat-tab [label]="source" *ngFor="let source of leadSources">
                                       <fury-partner-leads-table [dataSource]="dataSource" [itemList]="itemList" [columns]="columns" [leadSearchForm]="leadSearchForm" [partnerId]="partnerId" [pageIndex]="pageIndex" [pageSize]="pageSize" [leadSourceTabName]="leadSourceTabName" (search)="handleSearch($event)">
                                       </fury-partner-leads-table>
                                        <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
                                        showFirstLastButtons
                                        [selectConfig] = "selectConfig"
                                        [ngClass]="{'mat-pegig': pageSize === 9999}"
                                        aria-label="Select page of periodic elements">
                                        </mat-paginator>  
                                    </mat-tab>
                                </mat-tab-group>
                                 </div>
                        </mat-tab>
                        <mat-tab label="Phone">
                            <fury-common-kpi-blocks [mainPage]="'partnerDashboard'" [data]="partnerKpiData" [partnerDashboardTabName]="parentTabName"></fury-common-kpi-blocks>
                            <div class="tab-wrap">
                                <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)" *ngIf="parentTabName==='Phone'">
                                    <mat-tab [label]="source" *ngFor="let source of leadSources">
                                       <fury-call-rail-leads-table [dataSource]="callRailDataSource"  [columns]="callRailColumns" [leadSearchForm]="callRailLeadSearchForm" [partnerId]="partnerId" [pageIndex]="pageIndex" [pageSize]="pageSize" [tabName]="tabName" (search)="callRailHandleSearch($event)">
                                       </fury-call-rail-leads-table>
                                        <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="callRailPageSize" [length]="callRailTotalCount" [pageIndex]="callRailPageIndex" (page)="callRailPageSizeChange($event)"
                                        showFirstLastButtons
                                        [selectConfig] = "selectConfig"
                                        [ngClass]="{'mat-pegig': pageSize === 9999}"
                                        aria-label="Select page of periodic elements">
                                        </mat-paginator>  
                                    </mat-tab>
                                </mat-tab-group>
                                 </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
      </div>
       
   
</fury-page>




